import {useTranslation} from 'react-i18next';
import {Stack, TextField, IconButton, InputAdornment} from '@mui/material';
import {useState} from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import {type Plan, type Folder} from 'client';
import SearchIcon from '@mui/icons-material/Search';

export function SearchPlan({
  allPlans,
  setSelectedPlans,
  allFolders,
  setSelectedFolders,
}: {
  allPlans: Plan[] | undefined;
  setSelectedPlans: (plans) => void;
  allFolders: Folder[] | undefined;
  setSelectedFolders: (folders) => void;
}) {
  const {t} = useTranslation('common');
  const [value, setValue] = useState<string>('');
  const handleClearClick = () => {
    setValue('');
    setSelectedPlans(allPlans);
    setSelectedFolders(allFolders);
  };

  if (!allPlans) {
    return null;
  }

  return (
    <Stack direction={'row'} justifyContent={'center'} width={220} m={1.5}>
      <TextField
        id={'search-plan-filter'}
        onChange={(newValue) => {
          setValue(newValue.target.value);
          setSelectedPlans(getMatchingPlans(newValue.target.value, allPlans));
          allFolders && setSelectedFolders(getMatchingFolders(newValue.target.value, allFolders));
        }}
        fullWidth
        variant="outlined"
        size="small"
        value={value}
        placeholder={t('search') ?? ''}
        InputProps={{
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton size="small" edge="end" onClick={handleClearClick}>
                <ClearIcon color="secondary" />
              </IconButton>
            </InputAdornment>
          ) : (
            <InputAdornment position="end">
              <IconButton size="small" edge="end">
                <SearchIcon color="disabled" />
              </IconButton>
            </InputAdornment>
          ),
          style: {
            paddingRight: 8,
          },
        }}
      />
    </Stack>
  );
}

const getMatchingPlans = (search: string, plans: Plan[]) => {
  if (!plans) {
    return [];
  }

  const found: Plan[] = plans.filter((plan) => {
    const nameMatch = plan.name.toLowerCase().includes(search.toLowerCase());
    const descriptionMatch = plan.description?.toLowerCase().includes(search.toLowerCase());
    const tagsMatch = plan.tags
      ?.map((tag) => tag.toLowerCase())
      .join()
      .includes(search.toLowerCase());

    return nameMatch || (descriptionMatch ?? false) || tagsMatch;
  });

  return found;
};

const getMatchingFolders = (search: string, folders: Folder[]) => {
  if (!folders) {
    return [];
  }

  const found: Folder[] = folders.filter((folder) => {
    const nameMatch = folder.name.toLowerCase().includes(search.toLowerCase());

    return nameMatch;
  });

  return found;
};
